/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_AddInputs */

const vi_customer_group_add = /** @type {(inputs: Customer_Group_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm nhóm`)
};

/**

* @param {Customer_Group_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_add = /** @type {((inputs?: Customer_Group_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_add(inputs)
});